import { Component, OnInit } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';

import {
  NavigationItem,
  navigationItemsInvoices,
} from '../../models/navigation-item-model';
import { LabelService } from '../../services/label.service';
import { classes, pages } from '../../shared/labels';
import { InvoicesCompanyClientsComponent } from './invoices-company-clients/invoices-company-clients.component';
import { InvoicesPrivateClientsComponent } from './invoices-private-clients/invoices-private-clients.component';
import { PatientService } from '../../services/patient.service';
import { ErrorPanelService } from '../../services/error-panel.service';
import { InvoicesService } from '../../services/invoices.service';
import { InvoicesPrivatePanelComponent } from './invoices-private-panel/invoices-private-panel.component';
import { InvoicesCompanyPanelComponent } from './invoices-company-panel/invoices-company-panel.component';
import {
  InvoiceCompanyClient,
  InvoicePatient,
  InvoicePrivateClient,
} from '../../models/invoices';

@Component({
  selector: 'app-invoices-clients',
  standalone: true,
  imports: [
    SharedModule,
    InvoicesCompanyClientsComponent,
    InvoicesPrivateClientsComponent,
    InvoicesPrivatePanelComponent,
    InvoicesCompanyPanelComponent,
  ],
  templateUrl: './invoices-clients.component.html',
  styleUrl: './invoices-clients.component.scss',
})
export class InvoicesClientsComponent implements OnInit {
  navigationItems: NavigationItem[];
  showNewCompanyPanel: boolean = false;
  showNewPatientPanel: boolean = false;
  companyClients: InvoiceCompanyClient[] = [];
  privateClients: InvoicePrivateClient[] = [];
  patients: InvoicePatient[] = [];
  selectedCompanyClient!: InvoiceCompanyClient;
  selectedPrivateClient!: InvoicePrivateClient;

  isCompanySectionSelected: boolean = false;
  isPrivateSectionSelected: boolean = true;
  isLoadingPrivateClients: boolean = true;
  isLoadingCompanyClients: boolean = true;
  newCompanyPanelTitle: string = 'Nuovo Cliente aziendale';
  newPatientPanelTitle: string = 'Nuovo Cliente privato';

  constructor(
    public labelService: LabelService,
    private patientService: PatientService,
    private errorPanelService: ErrorPanelService,
    private invoicesService: InvoicesService
  ) {
    // highlight the correct page in the side bar
    this.navigationItems = navigationItemsInvoices.map((item) => {
      if (item.label === pages.client_list) {
        return { ...item, class: classes.hnb };
      }
      return { ...item };
    });
  }
  ngOnInit(): void {
    this.getCompanyClients();
    this.getPrivateClients();
    this.getPatients();
  }

  getCompanyClients() {
    this.invoicesService.getInvoicesCompanyClients().subscribe({
      next: (companyClients: InvoiceCompanyClient[]) => {
        this.companyClients = companyClients;
        this.isLoadingCompanyClients = false;
      },
      error: (error) => {
        console.error(error);
        this.errorPanelService.showErrorSnackBar(
          'Errore durante il caricamento dei clienti aziendali'
        );
        this.isLoadingCompanyClients = false;
      },
    });
  }

  getPrivateClients() {
    this.invoicesService.getInvoicesPrivateClients().subscribe({
      next: (privateClients: InvoicePrivateClient[]) => {
        this.privateClients = privateClients;
        this.isLoadingPrivateClients = false;
      },
      error: (error) => {
        console.error(error);
        this.errorPanelService.showErrorSnackBar(
          'Errore durante il caricamento dei clienti privati'
        );
        this.isLoadingPrivateClients = false;
      },
    });
  }

  getPatients() {
    this.patientService.getPatients().subscribe({
      next: (patients) => {
        this.patients = patients;
      },
      error: (error) => {
        console.error(error);
        this.errorPanelService.showErrorSnackBar(
          'Errore durante il caricamento dei clienti privati'
        );
      },
    });
  }

  toggleCompanyPanel(client?: InvoiceCompanyClient) {
    if (client) {
      this.selectedCompanyClient = client;
      this.newCompanyPanelTitle = 'Modifica Cliente Azienda';
    } else {
      this.selectedCompanyClient = {
        id: '',
        is_patient: false,
        patient_id: '',
        patient_first_name: '',
        tax_code: '',
        vat_number: '',
        patient_last_name: '',
        company_name: '',
        unique_code: '',
        zip_code: '',
        city: '',
        province: '',
        country: '',
        street_address: '',
        street_number: '',
        email: '',
      };
      this.newCompanyPanelTitle = 'Nuovo Cliente Azienda';
    }
    this.showNewCompanyPanel = !this.showNewCompanyPanel;
  }

  togglePrivatePanel(client?: InvoicePrivateClient) {
    if (client) {
      this.selectedPrivateClient = client;
      this.newPatientPanelTitle = 'Modifica Cliente Privato';
    } else {
      this.selectedPrivateClient = {
        id: '',
        is_patient: false,
        client_first_name: '',
        client_last_name: '',
        client_zip_code: '',
        client_email: '',
        client_number: '',
        client_tax_code: '',
        client_country: '',
        client_city: '',
        client_province: '',
        client_street_address: '',
        client_street_number: '',
      };
      this.newPatientPanelTitle = 'Nuovo Cliente Privato';
    }
    this.showNewPatientPanel = !this.showNewPatientPanel;
  }

  toggleCompanySection() {
    this.isCompanySectionSelected = true;
    this.isPrivateSectionSelected = false;
  }

  togglePatientSection() {
    this.isCompanySectionSelected = false;
    this.isPrivateSectionSelected = true;
  }

  createCompanyClient(client: InvoiceCompanyClient) {
    this.invoicesService.createInvoicesCompanyClients(client).subscribe({
      next: () => {
        this.getCompanyClients();
        this.toggleCompanyPanel();
      },
      error: (error) => {
        console.error(error);
        this.errorPanelService.showErrorSnackBar(
          'Errore durante la creazione del cliente aziendale'
        );
      },
    });
  }

  updateCompanyClient(client: InvoiceCompanyClient) {
    if (client.id) {
      this.invoicesService
        .updateInvoicesCompanyClients(client.id, client)
        .subscribe({
          next: () => {
            this.getCompanyClients();
            this.toggleCompanyPanel();
          },
          error: (error) => {
            console.error(error);
            this.errorPanelService.showErrorSnackBar(
              'Errore durante la modifica del cliente aziendale'
            );
          },
        });
    }
  }

  createPrivateClient(client: InvoicePrivateClient) {
    this.invoicesService.createInvoicesPrivateClients(client).subscribe({
      next: () => {
        this.getPrivateClients();
        this.togglePrivatePanel();
      },
      error: (error) => {
        console.error(error);
        this.errorPanelService.showErrorSnackBar(
          'Errore durante la creazione del cliente privato'
        );
      },
    });
  }

  updatePrivateClient(client: InvoicePrivateClient) {
    if (client.id) {
      this.invoicesService
        .updateInvoicesPrivateClients(client.id, client)
        .subscribe({
          next: () => {
            this.getPrivateClients();
            this.togglePrivatePanel();
          },
          error: (error) => {
            console.error(error);
            this.errorPanelService.showErrorSnackBar(
              'Errore durante la modifica del cliente privato'
            );
          },
        });
    }
  }

  deleteCompanyClient(client: InvoiceCompanyClient) {
    if (client.id) {
      this.invoicesService.deleteInvoicesCompanyClients(client.id).subscribe({
        next: () => this.getCompanyClients(),
        error: (error) => {
          console.error(error);
          this.errorPanelService.showErrorSnackBar(
            'Errore durante la cancellazione del cliente aziendale'
          );
        },
      });
    }
  }

  deletePrivateClient(client: InvoicePrivateClient) {
    if (client.id) {
      this.invoicesService.deleteInvoicesPrivateClients(client.id).subscribe({
        next: () => this.getPrivateClients(),
        error: (error) => {
          console.error(error);
          this.errorPanelService.showErrorSnackBar(
            'Errore durante la cancellazione del cliente privato'
          );
        },
      });
    }
  }
}
